import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "d-flex justify-content-end align-items-center mb-4" };
const _hoisted_4 = { class: "me-2 fw-medium text-black" };
const _hoisted_5 = { class: "ms-3 d-flex gap-2" };
const _hoisted_6 = ["onClick", "title"];
const _hoisted_7 = { class: "row" };
const _hoisted_8 = {
    key: 0,
    class: "col-md-12"
};
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_10 = { class: "col-md-6" };
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_12 = ["placeholder"];
const _hoisted_13 = { class: "col-md-6" };
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_15 = { class: "col-md-12" };
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_17 = { class: "mb-0" };
const _hoisted_18 = { class: "col-md-6" };
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_20 = { class: "form-check form-switch" };
const _hoisted_21 = {
    class: "form-check-label",
    for: "prioSwitch"
};
const _hoisted_22 = { class: "col-md-6" };
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_24 = { class: "form-check form-switch" };
const _hoisted_25 = {
    class: "form-check-label",
    for: "displaySizesSwitch"
};
const _hoisted_26 = { class: "col-md-6" };
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_28 = { class: "form-check form-switch" };
const _hoisted_29 = {
    class: "form-check-label",
    for: "recommendedSwitch"
};
const _hoisted_30 = { class: "col-md-12" };
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_32 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_33 = { class: "d-block text-black fw-semibold mb-0" };
const _hoisted_34 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_35 = {
    key: 1,
    class: "badge bg-warning"
};
const _hoisted_36 = { class: "card border-0 shadow-sm mb-3" };
const _hoisted_37 = { class: "card-body" };
const _hoisted_38 = { class: "row" };
const _hoisted_39 = { class: "col-md-12 mb-3" };
const _hoisted_40 = { class: "d-block text-black fw-medium mb-2" };
const _hoisted_41 = ["placeholder"];
const _hoisted_42 = { class: "col-md-12" };
const _hoisted_43 = { class: "d-block text-black fw-medium mb-2" };
const _hoisted_44 = { class: "mb-0" };
const _hoisted_45 = { class: "col-md-12" };
const _hoisted_46 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_47 = ["src"];
const _hoisted_48 = { class: "col-md-12" };
const _hoisted_49 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_50 = ["disabled"];
const _hoisted_51 = { class: "row" };
const _hoisted_52 = { class: "col-md-12" };
const _hoisted_53 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_54 = { class: "col-md-12" };
const _hoisted_55 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_56 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_QuillEditor = _resolveComponent("QuillEditor");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.language')) + ":", 1),
                _createVNode(_component_v_select, {
                    modelValue: _ctx.selectedLanguage,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedLanguage) = $event)),
                    options: _ctx.availableLanguages,
                    label: "name",
                    reduce: (lang) => lang.code,
                    class: "language-selector",
                    style: { "min-width": "150px" }
                }, null, 8, ["modelValue", "options", "reduce"]),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: lang.code,
                            class: _normalizeClass(["badge",
                                _ctx.isTranslationComplete(lang.code) ? 'bg-success' : 'bg-secondary'
                            ]),
                            style: { "cursor": "pointer" },
                            onClick: ($event) => (_ctx.selectedLanguage = lang.code),
                            title: _ctx.isTranslationComplete(lang.code)
                                ? `${lang.name} - ${_ctx.$t('category.complete')}`
                                : `${lang.name} - ${_ctx.$t('category.incomplete')}`
                        }, _toDisplayString(lang.code.toUpperCase()), 11, _hoisted_6));
                    }), 128))
                ])
            ]),
            (_ctx.userRole === _ctx.userRoleEnum.FRANCHISE || _ctx.userRole === _ctx.userRoleEnum.ADMIN)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _cache[15] || (_cache[15] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_7, [
                        (_ctx.userRole === _ctx.userRoleEnum.FRANCHISE)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Restaurant * ", -1)),
                                    _createVNode(_component_v_select, {
                                        modelValue: _ctx.selectedRestaurant,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                                        options: _ctx.restaurantOptions,
                                        label: "name",
                                        reduce: (restaurant) => restaurant.id,
                                        placeholder: _ctx.$t('forms.selectRestaurantPlaceholder'),
                                        class: "restaurant-select",
                                        onInput: _ctx.onRestaurantChange
                                    }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onInput"])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nom * ", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.name) }]),
                                    placeholder: _ctx.$t('forms.example') + ' ' + _ctx.$t('product.productName'),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.categorieData.name) = $event)),
                                    onChange: _cache[3] || (_cache[3] = (event) => _ctx.handleInput(event, 'name')),
                                    required: ""
                                }, null, 42, _hoisted_12), [
                                    [_vModelText, _ctx.categorieData.name]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Position ", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "Ex: 1",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.categorieData.position) = $event))
                                }, null, 512), [
                                    [
                                        _vModelText,
                                        _ctx.categorieData.position,
                                        void 0,
                                        { number: true }
                                    ]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Description ", -1)),
                                _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_component_QuillEditor, {
                                        theme: "snow",
                                        "content-type": "html",
                                        placeholder: _ctx.$t('forms.categoryDescriptionPlaceholder'),
                                        toolbar: "full",
                                        content: _ctx.categorieData.description,
                                        "onUpdate:content": _cache[5] || (_cache[5] = ($event) => ((_ctx.categorieData.description) = $event))
                                    }, null, 8, ["placeholder", "content"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Personnalisable ", -1)),
                                _createElementVNode("div", _hoisted_20, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        role: "switch",
                                        id: "prioSwitch",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.categorieData.prio) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.categorieData.prio]
                                    ]),
                                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.categorieData.prio ? "Oui" : "Non"), 1)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Afficher les tailles ", -1)),
                                _createElementVNode("div", _hoisted_24, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        role: "switch",
                                        id: "displaySizesSwitch",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.categorieData.display_sizes) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.categorieData.display_sizes]
                                    ]),
                                    _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.categorieData.display_sizes ? "Oui" : "Non"), 1)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Créer votre produit ", -1)),
                                _createElementVNode("div", _hoisted_28, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        role: "switch",
                                        id: "recommendedSwitch",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.categorieData.is_recommended) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.categorieData.is_recommended]
                                    ]),
                                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.categorieData.is_recommended ? "Oui" : "Non"), 1)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('category.multilingualTranslations')) + " - " + _toDisplayString(_ctx.getCurrentLanguageName()), 1),
                                    (_ctx.isTranslationComplete(_ctx.selectedLanguage))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                            _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fas fa-check me-1" }, null, -1)),
                                            _createTextVNode(_toDisplayString(_ctx.$t('category.complete')), 1)
                                        ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                            _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
                                            _createTextVNode(_toDisplayString(_ctx.$t('category.incomplete')), 1)
                                        ]))
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _createElementVNode("div", _hoisted_39, [
                                                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('common.name')) + " * ", 1),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control shadow-none rounded-0 text-black",
                                                    placeholder: `Nom de la catégorie en ${_ctx.getCurrentLanguageName()}`,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.currentTranslation.name) = $event)),
                                                    onBlur: _cache[10] || (_cache[10] = ($event) => (_ctx.saveTranslation(_ctx.selectedLanguage)))
                                                }, null, 40, _hoisted_41), [
                                                    [_vModelText, _ctx.currentTranslation.name]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_42, [
                                                _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('common.description')), 1),
                                                _createElementVNode("div", _hoisted_44, [
                                                    (_openBlock(), _createBlock(_component_QuillEditor, {
                                                        key: `description-${_ctx.selectedLanguage}-${_ctx.translationKey}`,
                                                        theme: "snow",
                                                        "content-type": "html",
                                                        placeholder: `Description en ${_ctx.getCurrentLanguageName()}`,
                                                        toolbar: "full",
                                                        content: _ctx.currentTranslation.description,
                                                        "onUpdate:content": [
                                                            _cache[11] || (_cache[11] = ($event) => ((_ctx.currentTranslation.description) = $event)),
                                                            _cache[12] || (_cache[12] = ($event) => (_ctx.saveTranslation(_ctx.selectedLanguage)))
                                                        ]
                                                    }, null, 8, ["placeholder", "content"]))
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Icone ", -1)),
                                (_ctx.categorieData.icone)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.categorieData.icone,
                                        class: "rounded-circle me-8 mb-4",
                                        width: "45",
                                        height: "45",
                                        alt: "categorie"
                                    }, null, 8, _hoisted_47))
                                    : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                    type: "file",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "**************",
                                    onChange: _cache[13] || (_cache[13] = (event) => _ctx.handleInput(event, 'file'))
                                }, null, 32)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                            (_ctx.actionDetected)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    (_ctx.isLoading)
                                        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                            type: "submit",
                                            disabled: !_ctx.isFormValid
                                        }, _toDisplayString(_ctx.actionDetected === "edit"
                                            ? "Mettre à jour"
                                            : " Ajouter une catégorie"), 11, _hoisted_50)),
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[14] || (_cache[14] =
                                            //@ts-ignore
                                            (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                        class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                    }, [...(_cache[29] || (_cache[29] = [
                                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                                            _createElementVNode("span", { class: "position-relative" }, "Annuler", -1)
                                        ]))])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ], 32))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _cache[18] || (_cache[18] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.addRestaurantCategorie && _ctx.addRestaurantCategorie(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Selectionner le categorie * ", -1)),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.categorieSelected,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.categorieSelected) = $event)),
                                    options: _ctx.resteCategorieModel,
                                    label: "name",
                                    reduce: (categorie) => categorie.id,
                                    placeholder: "Restaurant"
                                }, null, 8, ["modelValue", "options", "reduce"])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                            (_ctx.actionDetected)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                    (_ctx.isLoading)
                                        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.categorieSelected }]),
                                            type: "submit",
                                            disabled: !_ctx.categorieSelected
                                        }, " Ajouter cette categorie ", 10, _hoisted_56)),
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[17] || (_cache[17] =
                                            //@ts-ignore
                                            (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                        class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                    }, [...(_cache[31] || (_cache[31] = [
                                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                                            _createElementVNode("span", { class: "position-relative" }, "Annuler", -1)
                                        ]))])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ], 32))
        ])
    ]));
}
